import {createFeatureSelector, createSelector} from '@ngrx/store';
import { exportRequestChildrenMapFeatureKey } from './export-requests-children.reducer';
import { ExportRequestsState } from '../export-requests/export-requests.reducer';

const selectChildrenMapState = createFeatureSelector<ExportRequestsState>(exportRequestChildrenMapFeatureKey);

export const selectExportRequestChildrenForm = createSelector(
    selectChildrenMapState,
    state => state
);

